import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import AuthorisedRoute from './AuthorisedRoute';
import { AppContainer } from '../Components/globalStyles';
import { navbarMenuItems } from '../Constants/constants';
import { isPublicView } from '../settings';
import RouterContent from './RouterContent';

const Router = () => {
  return !isPublicView ? (
    <AppContainer>
      <BrowserRouter>
        <RouterContent>
          <Switch>
            {navbarMenuItems.map((item, index) => (
              <AuthorisedRoute path={item.link} page={item.page} key={index} />
            ))}
            <Redirect to="/ClosureEvent" />
          </Switch>
        </RouterContent>
      </BrowserRouter>
    </AppContainer>
  ) : (
    <BrowserRouter>
      <Switch>
        <AuthorisedRoute
          path={'/Registration'}
          page={'PublicView/ClosureRegistration'}
        />
        <AuthorisedRoute
          path={'/MessageHistory'}
          page={'PublicView/MessageHistory'}
        />
        <AuthorisedRoute
          path={'/ManageLocation'}
          page={'PublicView/ManageLocation'}
        />
        <AuthorisedRoute path={'/'} page={'PublicView'} />
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
